var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Campaigns---6-months-in",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Campaigns-&-Assets-Home",
    transform: "translate(-902.000000, -205.000000)",
    fill: "#7E7E7E",
    fillRule: "nonzero",
    stroke: "#7E7E7E",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-options",
    transform: "translate(178.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy",
    transform: "translate(712.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_event_1563699",
    transform: "translate(13.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.975,17.85 L14.875,17.85 C16.5180471,17.85 17.85,16.5180471 17.85,14.875 L17.85,4.4625 C17.85,2.81945287 16.5180471,1.4875 14.875,1.4875 L14.13125,1.4875 L14.13125,0.74375 C14.13125,0.332988217 13.7982618,0 13.3875,0 C12.9767382,0 12.64375,0.332988217 12.64375,0.74375 L12.64375,1.4875 L9.66875,1.4875 L9.66875,0.74375 C9.66875,0.332988217 9.33576178,0 8.925,0 C8.51423822,0 8.18125,0.332988217 8.18125,0.74375 L8.18125,1.4875 L5.20625,1.4875 L5.20625,0.74375 C5.20625,0.332988217 4.87326178,0 4.4625,0 C4.05173822,0 3.71875,0.332988217 3.71875,0.74375 L3.71875,1.4875 L2.975,1.4875 C1.33195287,1.4875 0,2.81945287 0,4.4625 L0,14.875 C0,16.5180471 1.33195287,17.85 2.975,17.85 Z M14.875,16.3625 L2.975,16.3625 C2.15347643,16.3625 1.4875,15.6965236 1.4875,14.875 L1.4875,7.4375 L16.3625,7.4375 L16.3625,14.875 C16.3625,15.6965236 15.6965236,16.3625 14.875,16.3625 Z M2.975,2.975 L3.71875,2.975 L3.71875,3.71875 C3.71875,4.12951178 4.05173822,4.4625 4.4625,4.4625 C4.87326178,4.4625 5.20625,4.12951178 5.20625,3.71875 L5.20625,2.975 L8.18125,2.975 L8.18125,3.71875 C8.18125,4.12951178 8.51423822,4.4625 8.925,4.4625 C9.33576178,4.4625 9.66875,4.12951178 9.66875,3.71875 L9.66875,2.975 L12.64375,2.975 L12.64375,3.71875 C12.64375,4.12951178 12.9767382,4.4625 13.3875,4.4625 C13.7982618,4.4625 14.13125,4.12951178 14.13125,3.71875 L14.13125,2.975 L14.875,2.975 C15.6965236,2.975 16.3625,3.64097643 16.3625,4.4625 L16.3625,5.95 L1.4875,5.95 L1.4875,4.4625 C1.4875,3.64097643 2.15347643,2.975 2.975,2.975 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6298099,9.55753496 L8.18135338,11.8892006 L7.22019013,10.9738847 C6.92961656,10.6971714 6.45850374,10.6971714 6.16793017,10.9738847 C5.87735661,11.2505979 5.87735661,11.6992388 6.16793017,11.9759521 L7.6552234,13.3923018 C7.7947079,13.5252807 7.98398269,13.6 8.18135338,13.6 C8.37872407,13.6 8.56799886,13.5252807 8.70748336,13.3923018 L11.6820698,10.5596024 C11.9726434,10.2828891 11.9726434,9.83424823 11.6820698,9.55753496 C11.3914963,9.28082168 10.9203834,9.28082168 10.6298099,9.55753496 Z",
    id: "Path"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/Calender.7299d08c.svg";
export { ForwardRef as ReactComponent };